import { render, staticRenderFns } from "./NfcQrGenerator.vue?vue&type=template&id=1d20aad8&scoped=true"
import script from "./NfcQrGenerator.vue?vue&type=script&lang=js"
export * from "./NfcQrGenerator.vue?vue&type=script&lang=js"
import style0 from "./NfcQrGenerator.vue?vue&type=style&index=0&id=1d20aad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20aad8",
  null
  
)

export default component.exports